module.exports = __webpack_public_path__ + "static/media/clothes.fda13b67.svg";